export default function (fn, wait) {
  let timer

  return function (...args) {
    if (timer) {
      clearTimeout(timer) // clear any pre-existing timer
    }
    timer = setTimeout(() => {
      fn.apply(this, args) // call the function if time expires
    }, wait)
  }
}
